import React, { useCallback } from 'react';
import { MenuItemGroup } from 'rc-menu';
import { unifiedStopPropagation } from '../../../util/unifiedStopPropagation';
import { getItemsIntoComponentsTransformer } from '../util/getItemsIntoComponentsTransformer';
import { DropdownComponentProps } from './types';

const MenuItemGroupGroupTitle: React.FC<{ title: string }> = ({ title }) => (
  <div onClick={unifiedStopPropagation}>{title}</div>
);

export const DropdownItemGroup: React.FC<DropdownComponentProps> = ({
  item,
  itemLevel,
  ...props
}) => {
  const transformItemsIntoComponents = useCallback(
    getItemsIntoComponentsTransformer(itemLevel),
    [itemLevel],
  );

  return (
    <MenuItemGroup
      {...props}
      // @ts-expect-error: Investigate nad fix.
      title={<MenuItemGroupGroupTitle title={item.title()} />}
    >
      {transformItemsIntoComponents(item.children())}
    </MenuItemGroup>
  );
};

DropdownItemGroup.displayName = 'DropdownItemGroup';
